import { useContext } from 'react'
import { IProyectos } from '../../../data/data.model'
import FiltersContext from '../../../../Context/FiltersContext'
import { Tooltip } from '@mui/material'

type Direction = 'up' | 'down' | 'left' | 'right'

interface TriangleProps {
  project?: IProyectos
  size: number
  fill?: string
  direction?: Direction
}

export const ProjectTriangle = ({
  project,
  size,
  fill = 'none',
  direction = 'up',
}: TriangleProps) => {
  const { setProjectSelected } = useContext(FiltersContext)

  const sides = 3
  const angle = (2 * Math.PI) / sides

  // Rotaciones base según dirección
  const directionRotationMap: Record<Direction, number> = {
    up: -Math.PI / 2,
    down: Math.PI / 2,
    left: Math.PI,
    right: 0,
  }

  const rotationOffset = directionRotationMap[direction]

  const points = Array.from({ length: sides }, (_, i) => {
    const x = size * Math.cos(angle * i + rotationOffset)
    const y = size * Math.sin(angle * i + rotationOffset)
    return `${x},${y}`
  }).join(' ')

  const handleProjectClick = () => {
    setProjectSelected(project)
  }

  return (
    <Tooltip title={project?.property_name_or_project_name} arrow>
      <div
        style={{
          // padding: 2,
          maxHeight: size * 2,
          alignSelf: 'flex-start',
          cursor: project ? 'pointer' : 'default',
        }}
        onClick={project ? handleProjectClick : undefined}
      >
        <svg
          viewBox={`${-size} ${-size} ${2 * size} ${2 * size}`}
          width={size * 2}
          height={size * 2}
        >
          <polygon points={points} fill={fill} />
        </svg>
      </div>
    </Tooltip>
  )
}
